import { type AxiosRequestConfig } from 'axios'

const getUserOrganization = (id?: string): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: id ? `/users/${id}/info/organization` : '/user/info/organization'
  }
}

export { getUserOrganization }
